import { eLanThiTongHop } from "../../../model/common/eLanThiTongHop";
import { getDefaultHocKy, getDefaultNamHoc } from "../../../utils/getDefaultValue";
import { ITongHopKyActionTypes } from "../../action-types/tong-hop-diem/ITongHopKyActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITongHopKyReducer } from "../../reducer-model/tong-hop-diem/ITongHopDiemReducer";

const iniState : ITongHopKyReducer = {
    status: eReducerStatusBase.is_not_initialization,
    tongHopDiem: {
       chuongtrinhdaotaochitietlist: [],
       ketquatonghop: []
    },
    filter: {
        id_dts: "",
        id_svs: "",
        hoc_ky: getDefaultHocKy(),
        nam_hoc: getDefaultNamHoc(),
        lan_thi: eLanThiTongHop.CAO_NHAT,
        id_lops: "",
        trang_thai_hocs: "0",
        is_hien_thi_mon_dung_tien_do: true,
        is_tinh_tich_luy_toan_khoa: true,
    }
}

export const TongHopKyReducer = (state: ITongHopKyReducer = iniState, action: ITongHopKyActionTypes): ITongHopKyReducer => {
    switch (action.type) {
        case "TONG_HOP_KY_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "TONG_HOP_KY_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                tongHopDiem: action.payload
            };
        case "TONG_HOP_KY_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "TONG_HOP_KY_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload,
            };
        case "TONG_HOP_KY_CHANGED_FOCUSED_VALUE_LOP":
            return {
                ...state,
                focusedValueLop: action.payload,
                filter: {
                    ...state.filter,
                    id_lops: action.payload.id_lops.join(",")
                },
                tongHopDiem: {
                    ...state.tongHopDiem,
                    chuongtrinhdaotaochitietlist: [],
                    ketquatonghop: []
                }
            };
        default:
            return state;
    }
}